import { isNil } from '@pct-ts/typeguard';

export function canInstallPWA(): boolean {
  // Chrome/Edge support
  const isBeforeInstallPromptSupported = 'onbeforeinstallprompt' in window;
  // Safari support
  const isStandaloneOnSafari = 'standalone' in navigator && !isNil(navigator.standalone);
  return isBeforeInstallPromptSupported || isStandaloneOnSafari;
}
